const validateEmail = (email) => {
  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  return regex.test(email) && !/\.\./.test(email);
};

const validateName = (name) => {
  const regName = /^[A-Za-z\s]+$/;
  return regName.test(name);
};

const validateNameWithNum = (orgName) => {
  const regOrgName = /^[A-Za-z0-9\s&.-]+$/;
  const isValid = regOrgName.test(orgName);
  // console.log("OrgName Validation:", orgName, isValid);
  return isValid;
};

const validateMobileNumber = (mobile) => {
  const regMobile = /^[0-9]{10}$/;
  return regMobile.test(mobile);
};

const spaceCheck = (value) => {
  const inputCheck = /^\s+|\s+$/g;
  // const inputCheck = /^[a-zA-Z\s]+$/;
  return inputCheck.test(value);
};

export {
  validateEmail,
  validateName,
  validateNameWithNum,
  validateMobileNumber,
  spaceCheck,
};
